import React from 'react';

import FlatButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import AddVendorForm from './AddVendorForm';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const AddVendorDialog = props => {
  return (
    <Dialog
      disableBackdropClick
      fullScreen={props.fullScreen}
      open={props.addVendorDialogIsOpen}
      onClose={props.closeAddVendorDialog}
      aria-labelledby="add-vendor"
      classes={{
        paper: 'form-dialog',
      }}
    >
      <DialogTitle id="add-vendor">
        <h3 style={{ textAlign: 'center', margin: 0 }}>
          {props.editVendor
            ? getTranslatedString('landlordPortal.vendors.editVendor')
            : getTranslatedString('landlordPortal.vendors.addVendor')}
        </h3>
      </DialogTitle>

      <DialogContent>
        <AddVendorForm
          onSubmit={props.submitForm}
          handleClose={props.closeAddVendorDialog}
          initialValues={props.vendorDetails}
        />
      </DialogContent>

      <DialogActions style={{ display: 'block' }}>
        <FlatButton
          onClick={props.closeAddVendorDialog}
          id="close-button"
          style={{ color: AccentColor() }}
        >
          {getTranslatedString('landlordPortal.vendors.close')}
        </FlatButton>

        <FlatButton
          onClick={() => props.submit('add_vendor_form')}
          disabled={props.submitting}
          id="submit-button"
          style={{ color: props.submitting ? colors.LIGHT_GRAY : AccentColor() }}
        >
          {getTranslatedString('landlordPortal.vendors.save')}
        </FlatButton>
      </DialogActions>
    </Dialog>
  );
};

export default withMobileDialog()(AddVendorDialog);
